import React, { Component } from "react";
import { connect } from "react-redux";
import { createFraud } from "../../../actions/masters/fraudActions";
import { Link } from "react-router-dom";
import FraudTypeForm from "./FraudTypeForm";
import history from "../../../history";

class FraudTypeCreate extends Component {
  onSubmit = (formValues) => {
    this.props.createFraud(formValues);
  };

  render() {
    return (
      <div className="BodyInContainer">
        <div className="d-block clearfix">
          <div className="Header-Content float-start">
            <h3 className="pageMainTitle">Add a Fraud Type</h3>
          </div>
          <div className="float-end mt-15">
            <Link
              className="float-end cardBackBtn"
              onClick={() => {
                history.goBack();
              }}
            >
              Back
            </Link>
          </div>
        </div>
        <FraudTypeForm onSubmit={this.onSubmit} />
      </div>
    );
  }
}
export default connect(null, { createFraud })(FraudTypeCreate);
